export default class ProductsNotPresentException extends Error {
    constructor(message: string) {
        super(message);
    }
}